import React from "react";
import ResponsiveColumn from "./ResponsiveColumn.jsx";
import ResponsiveRows from "./ResponsiveRows.jsx";
import {scssColors} from "../util/config.jsx";

class ComponentsColor extends React.PureComponent {
    constructor(props){
        super(props);
    }

    render(){
        const translateName = name => {
            let result = "";
            for (let i=0; i<name.length; i++) {
                if (name[i] === "-") {
                    i++;
                    result += `${name[i].toUpperCase()}`;
                } else {
                    result += name[i];
                }
            }
            return result;
        };
        const secondary = [
            "color-cyprus",
            "color-chambray",
            "color-medium-sea-green",
            "color-fire-brick",
            "color-storm-grey",
            "color-fun-blue",
            "color-light-slate-grey",
            "color-dark-orange",
            "color-sunset-orange",
            "color-light-cinnabar",
            "color-solitude",
            "color-dark-solitude",
            "color-venetian-red",
        ];
        const primary = [
            "color-cinnabar",
            "color-regal-blue",
            "color-cardinal"
        ];
        const colorToColumn = (colorArray, width) => colorArray.map( color => (
            <ResponsiveColumn key={translateName(color)} xs={width}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    borderRadius: "30px",
                    border: "solid 1px rgba(75, 88, 123, 0.05)",
                    backgroundColor: scssColors[translateName(color)],
                    color: scssColors.colorBlack
                }} />
                {`$${color}`}
            </ResponsiveColumn>
        ));
        return (
            <div style={{display:"flex"}}>
                <div style={{padding:"10px", width:"190px"}}>
                    <div className="card-warning">
                        <ResponsiveRows>
                            <ResponsiveColumn xs={12}>
                                <label className="label16bold">
                                    PRIMARY
                                </label>
                            </ResponsiveColumn>
                            {colorToColumn(primary,12)}
                        </ResponsiveRows>
                    </div>
                </div>
                <div style={{padding:"10px", width:"600px"}}>
                    <div className="card-default">
                        <ResponsiveRows>
                            <ResponsiveColumn xs={12}>
                                <label className="label16bold">
                                    SECONDARY
                                </label>
                            </ResponsiveColumn>
                            {colorToColumn(secondary,4)}
                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

ComponentsColor.propTypes = {
};

export default ComponentsColor;